import {
  EWorkshopPartType,
  TPartsUI,
} from '../../../../../../data/types/workshops.types';

export const getDefaultParts = (): TPartsUI[] => {
  return [
    {
      date: {
        value: '2023-09-01T14:00:00.000Z',
        allowedOperations: { readonly: true },
      },
      partType: EWorkshopPartType.PART_ONE,
      workshopPartId: '1',
      isPassed: false,
    },
    {
      date: {
        value: '2023-10-01T14:00:00.000Z',
        allowedOperations: { readonly: true },
      },
      partType: EWorkshopPartType.PART_TWO,
      workshopPartId: '2',
      isPassed: false,
    },
    {
      date: {
        value: '2023-11-01T14:00:00.000Z',
        allowedOperations: { readonly: true },
      },
      partType: EWorkshopPartType.PART_THREE,
      workshopPartId: '3',
      isPassed: false,
    },
  ] as TPartsUI[];
};
